import { createUseStyles } from 'react-jss'
import { GRAY } from '@omnilert/components'

const useStyles = createUseStyles({
  accordionWrapper: {
    padding: '0px 50px 10px 10px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  details: {
    display: 'flex',
    flexDirection: 'column'
  },
  divider: {
    backgroundColor: GRAY,
    height: '1px',
    margin: '5px 0',
    width: '100%'
  },
  summaryText: {
    fontWeight: '700 !important'
  },
  text: {
    padding: '10px 0'
  },
  titleText: {
    fontWeight: '600 !important'
  }
})

export default useStyles
